<template>
  <div class="wrap">
    <div class="header_title">
      <div class="header_center">
        <div class="title">
          申报奖项:
          <span>贵州省建筑业协会单位会员入会申请表</span>
        </div>
        <div class="back_page" @click="backpage">返回上一页</div>
      </div>
    </div>
    <div class="form_box">
      <div class="nav_left">
        <div class="nav_title">导航</div>
        <div class="nav_list">
          <!-- 导航栏列表 -->
          <div class="list" v-for="(item, index) in lefttitlelist" @click="scrollleft(item.name, item.id)" :key="index">
            <img class="tips" v-if="item.isok" src="@/assets/6598@2x.png" alt />
            <img class="tips" v-else src="@/assets/6668@2x.png" alt />
            <p>{{ item.name }}</p>
          </div>
        </div>
        <div class="preview">
          <!-- 左边三个按钮 -->
          <div class="preservation" @click="SaveDraftleft">
            <img src="@/assets/19158@2x.png" alt />
            <p>保存草稿</p>
          </div>
          <div class="online" @click="printPdf">
            <img src="@/assets/19160@2x.png" alt />
            <p>在线预览</p>
          </div>
          <div class="sumbit" :class="issumbit ? 'blue' : ''" @click="sumbit">
            <img src="@/assets/19178@2x.png" alt />
            <p>提交审核</p>
          </div>
        </div>
      </div>
      <div class="form_right" id="exportPdf" ref="exportPdf">
        <div class="form_1" id="form_1">
          <Tips
            title="填表说明"
            :background="'#EDF8F5'"
            :border="'#1ABF98'"
            :states="true"
          ></Tips>
          <div
            class="form_box_content"
            style="text-align: start; font-size: 14px; color: #0c0d0f"
          >
            <p>
              一、省外入黔企业必须填写在黔分公司营业执照上的统一社会信用代码、法人身份证号、单位地址。<br />
              二、会员证字号由审核单位填写。<br />
              三、表格填写完成后提交并打印，法人签字盖章后上传。<br />
            </p>
          </div>
        </div>
        <div class="form_1" id="unitinfo">
          <Tips
            title="单位信息"
            :background="unitinfotips ? '#EDF8F5' : '#FEF8EF'"
            :border="unitinfotips ? '#1ABF98' : '#FFB700'"
            :states="unitinfotips"
          ></Tips>
            <div class="my_form" style="margin-top: 20px">
              <div class="form_title" style="height: 62px">是否施工企业申请</div>
              <div class="form_content">
                <el-radio-group v-model="unitinfo.isuploadisshow" size="small" class="inpyabeb">
                  <el-radio label="1">施工企业申请</el-radio>
                  <el-radio label="0">非施工企业申请</el-radio>
                </el-radio-group>
              </div>
            </div>
          <div class="my_form">
            <div class="form_title" style="height: 62px">勾选承诺</div>
            <div class="form_long" style="text-align: start">
              <el-checkbox name="type" v-model="unitinfo.Tick"></el-checkbox
              ><span style="margin-left: 10px"
                >我单位自愿申请加入贵州省建筑业协会，承认本会章程，享受会员权利的同时，愿意履行会员义务和积极缴纳会费。</span
              >
            </div>
          </div>
          <div class="flex">
            <div class="my_form2">
              <div class="form_title" style="height: 62px">
                单位全称
              </div>
              <div class="form_content">
                <div class="input">
                  <input type="text" placeholder="请输入" v-model="unitinfo.unitname" />
                </div>
              </div>
            </div>
            <div class="my_form2">
              <div class="form_title" style="height: 62px">是否为省外企业</div>
              <div class="form_content">
                <el-checkbox name="type" v-model="unitinfo.isout">是</el-checkbox>
              </div>
            </div>
          </div>
          <div class="flex">
            <div class="my_form">
              <div class="form_title" style="height: 62px">
                统一社会信用代码
              </div>
              <div class="form_content">
                <div class="input">
                  <input type="text" placeholder="请输入" v-model="unitinfo.creditcode" />
                </div>
              </div>
            </div>
            <div class="my_form">
              <div class="form_title" style="height: 62px">法人身份证号</div>
              <div class="form_content">
                <div class="input">
                  <input type="text" placeholder="请输入" v-model="unitinfo.IDnumber" />
                </div>
              </div>
            </div>
          </div>
          <div class="my_form2">
            <div class="form_title" style="height: 62px">单位地址</div>
            <div class="form_long">
              <input placeholder="请输入" type="text" v-model="unitinfo.Unitaddress" />
            </div>
          </div>
          <div class="flex" v-if="unitinfo.isuploadisshow=='1'">
            <div class="my_form">
              <div class="form_title" style="height: 62px">主项资质类别</div>
              <div class="form_content">
                <div class="input">
                  <input type="text" placeholder="请输入" v-model="unitinfo.category" />
                </div>
              </div>
            </div>
            <div class="my_form">
              <div class="form_title" style="height: 62px">主项资质等级</div>
              <div class="form_content">
                <div class="input">
                  <input type="text" placeholder="请输入" v-model="unitinfo.level" />
                </div>
              </div>
            </div>
          </div>
          <div class="flex">
            <div class="my_form2">
              <div class="form_title" style="height: 62px">联系人姓名</div>
              <div class="form_content">
                <div class="input">
                  <input type="text" placeholder="请输入" v-model="unitinfo.Contactname" />
                </div>
              </div>
            </div>
            <div class="my_form2">
              <div class="form_title" style="height: 62px">手机号码</div>
              <div class="form_content">
                <div class="input">
                  <input type="text" placeholder="请输入" v-model="unitinfo.phone" />
                </div>
              </div>
            </div>
          </div>
          <div class="flex">
            <div class="my_form">
              <div class="form_title" style="height: 62px">
                联系人QQ（选填）
              </div>
              <div class="form_content">
                <div class="input">
                  <input type="text" placeholder="请输入" v-model="unitinfo.qq" />
                </div>
              </div>
            </div>
            <div class="my_form">
              <div class="form_title" style="height: 62px">
                办公电话（选填）
              </div>
              <div class="form_content">
                <div class="input">
                  <input type="text" placeholder="请输入" v-model="unitinfo.Officetelephone" />
                </div>
              </div>
            </div>
          </div>
          <div class="flex">
            <div class="my_form2">
              <div class="form_title" style="height: 62px">
                入黔企业分公司名称（省外企业必填）
              </div>
              <div class="form_content">
                <div class="input">
                  <input type="text" placeholder="请输入" v-model="unitinfo.corporatename" />
                </div>
              </div>
            </div>
            <div class="my_form2">
              <div class="form_title" style="height: 62px">
                隶属关系（省外企业必填）
              </div>
              <div class="form_content">
                <div class="input">
                  <input type="text" placeholder="请输入" v-model="unitinfo.Subordination" />
                </div>
              </div>
            </div>
          </div>
          <div class="flex">
            <div class="my_form">
              <div class="form_title" style="height: 62px">
                在黔机构负责人姓名（省外企业必填）
              </div>
              <div class="form_content">
                <div class="input">
                  <input type="text" placeholder="请输入" v-model="unitinfo.personincharge" />
                </div>
              </div>
            </div>
          </div>
          <div class="form_title">
            <p style="padding: 20px 0; text-align: start">证件信息</p>
          </div>
          <div class="flex">
            <div class="my_form2">
              <div class="form_title" style="height: 110px">
                营业执照（入黔企业必须上传在黔分公司营业执照）
              </div>
              <el-upload
                style="height: 110px"
                class="upload-demo"
                :action="$baseURL+'/api/home/upload/file/user'"
                :on-remove="(value) =>handleremove(1)"
                :on-success="(value) => handlesuccess2(1, value)"
                :file-list="unitinfo.Businesslicense1"
                list-type="picture"
              >
                <el-button
                  size="small"
                  icon="el-icon-plus"
                  style="margin-right: 10px"
                  >选择文件</el-button
                >
                <div
                  slot="tip"
                  class="el-upload__tip"
                  v-if="unitinfo.Businesslicense1!== undefined&&unitinfo.Businesslicense1.length < 1"
                >
                  只能上传jpg/png文件，且不超过500kb
                </div>
              </el-upload>
              <el-dialog :visible.sync="dialogVisible">
                <img width="100%" :src="dialogImageUrl" alt="" />
              </el-dialog>
            </div>
          </div>
          <div class="flex" v-if="unitinfo.isuploadisshow=='1'">
            <div class="my_form">
              <div class="form_title" style="height: 110px">主项资质证书</div>
              <el-upload
                style="height: 110px"
                class="upload-demo"
                :action="$baseURL+'/api/home/upload/file/user'"
                :on-remove="(value) =>handleremove(2)"
                :on-success="(value) => handlesuccess2(2, value)"
                :file-list="unitinfo.Businesslicense2"
                list-type="picture"
              >
                <el-button
                  size="small"
                  icon="el-icon-plus"
                  style="margin-right: 10px"
                  >选择文件</el-button
                >
                <div
                  slot="tip"
                  class="el-upload__tip"
                  v-if="unitinfo.Businesslicense2!== undefined&&unitinfo.Businesslicense2.length < 1"
                >
                  只能上传jpg/png文件，且不超过500kb
                </div>
              </el-upload>
              <el-dialog :visible.sync="dialogVisible">
                <img width="100%" :src="dialogImageUrl" alt="" />
              </el-dialog>
            </div>
          </div>
          <div class="flex" v-if="unitinfo.isuploadisshow=='1'">
            <div class="my_form2">
              <div class="form_title" style="height: 110px">安全生产许可证</div>
              <el-upload
                style="height: 110px"
                class="upload-demo"
                :action="$baseURL+'/api/home/upload/file/user'"
                :on-remove="(value) =>handleremove(3)"
                :on-success="(value) => handlesuccess2(3, value)"
                :file-list="unitinfo.Businesslicense3"
                list-type="picture"
              >
                <el-button
                  size="small"
                  icon="el-icon-plus"
                  style="margin-right: 10px"
                  >选择文件</el-button
                >
                <div
                  slot="tip"
                  class="el-upload__tip"
                  v-if="unitinfo.Businesslicense3!== undefined&&unitinfo.Businesslicense3.length < 1"
                >
                  只能上传jpg/png文件，且不超过500kb
                </div>
              </el-upload>
              <el-dialog :visible.sync="dialogVisible">
                <img width="100%" :src="dialogImageUrl" alt="" />
              </el-dialog>
            </div>
          </div>
          <div class="flex" v-if="unitinfo.isuploadisshow=='0'">
            <div class="my_form2">
              <div class="form_title" style="height: 110px">社团登记证</div>
              <el-upload
                style="height: 110px"
                class="upload-demo"
                :action="$baseURL+'/api/home/upload/file/user'"
                :on-remove="(value) =>handleremove(4)"
                :on-success="(value) => handlesuccess2(4, value)"
                :file-list="unitinfo.Businesslicense4"
                list-type="picture"
              >
                <el-button
                  size="small"
                  icon="el-icon-plus"
                  style="margin-right: 10px"
                  >选择文件</el-button
                >
                <div
                  slot="tip"
                  class="el-upload__tip"
                  v-if="unitinfo.Businesslicense4!== undefined&&unitinfo.Businesslicense4.length < 1"
                >
                  只能上传jpg/png文件，且不超过500kb
                </div>
              </el-upload>
              <el-dialog :visible.sync="dialogVisible">
                <img width="100%" :src="dialogImageUrl" alt="" />
              </el-dialog>
            </div>
          </div>
          <div class="flex">
            <div class="my_form2">
              <div class="form_title" style="height: 110px">入会申请表</div>
              <el-upload
                style="height: 110px"
                class="upload-demo"
                :action="$baseURL+'/api/home/upload/file/user'"
                :on-remove="(value) =>handleremove(5)"
                :on-success="(value) => handlesuccess2(5, value)"
                :file-list="unitinfo.Businesslicense5"
                list-type="picture"
              >
                <el-button
                  size="small"
                  icon="el-icon-plus"
                  style="margin-right: 10px"
                  >选择文件</el-button
                >
                <div
                  slot="tip"
                  class="el-upload__tip"
                  v-if="unitinfo.Businesslicense5!== undefined&&unitinfo.Businesslicense5.length < 1"
                >
                  只能上传jpg/png文件，且不超过500kb
                </div>
              </el-upload>
              <el-dialog :visible.sync="dialogVisible">
                <img width="100%" :src="dialogImageUrl" alt="" />
              </el-dialog>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Tips from "@/components/Modal/tips"; //提示组件
import { Apply,Memberdraft,Memberdraftdetail } from '../../utils/api.js'
export default {
  components: {
    Tips,
  },
  data() {
    return {
        issumbit:false,
        Tick:false,
        dialogVisible:false,
        dialogImageUrl:'',
        lefttitlelist: [
            { name: "填表说明", isok: true,id:"form_1" },
            { name: "单位信息", isok: false,id:"unitinfo" }
        ],
        unitinfo:{
            Tick:false,
            isout:false,
            isuploadisshow:'1',
            Businesslicense1: [],
            Businesslicense2: [],
            Businesslicense3: [],
            Businesslicense4: [],
            Businesslicense5: []
        },
        unitinfotips:false
    };
  },
  watch:{
    "unitinfo":{
      handler(){
        let unitinfotips = true
        let obj = {}
        // console.log(this.unitinfo);
        if (this.unitinfo.isout) {
          for (const key in this.unitinfo) {
            if (key=='qq'||key=='Officetelephone'||key=="isout") {
              continue
            }
            obj[key] = this.unitinfo[key]
          }
        }else{
          for (const key in this.unitinfo) {
            if (key=='Officetelephone'||key=='Subordination'||key=='corporatename'||key=='personincharge'||key=='qq'||key=="isout") {
              continue
            }
            obj[key] = this.unitinfo[key]
          }
        }
        if (obj.isuploadisshow=='1') {
          delete obj.Businesslicense4
          obj.Businesslicense2 = this.unitinfo.Businesslicense2
          obj.Businesslicense3 = this.unitinfo.Businesslicense3
        }else{
          delete obj.Businesslicense2
          delete obj.Businesslicense3
          obj.Businesslicense4 = this.unitinfo.Businesslicense4
        }
        
        for (const key in obj) {
          if (obj[key]==""||obj[key]==null||obj[key]==undefined) {
            unitinfotips = false
          }
        }
        this.unitinfotips = unitinfotips
        if (unitinfotips&&this.unitinfo.Tick) {
          this.issumbit = true
        }else{
          this.issumbit = false
        }
        this.lefttitlelist[1].isok = unitinfotips
      },
      deep:true
    }
  },
  async created(){
    let res = await Memberdraftdetail()
    if (res.content) {
      this.unitinfo = res.content
    }else{
      this.unitinfo.Businesslicense1 = []
      this.unitinfo.Businesslicense2 = []
      this.unitinfo.Businesslicense3 = []
      this.unitinfo.Businesslicense4 = []
      this.unitinfo.Businesslicense5 = []
    }
  },
  methods: {
    //返回上一页
    backpage() {
      this.$router.go(-1);
    },
    //保存草稿
    async SaveDraftleft() {
      let res = await Memberdraft(this.unitinfo)
      this.$message({
        message:'保存草稿成功',
        type:'success'
      })
    },
    //在线预览
    async printPdf() {
      if (this.unitinfo.isuploadisshow=='1') {
        this.unitinfo.Businesslicense4 = []
      }else{
        this.unitinfo.Businesslicense2 = []
        this.unitinfo.Businesslicense3 = []
      }
        let res = await Memberdraft(this.unitinfo)
        sessionStorage.setItem("unitinfo", JSON.stringify(this.unitinfo));
        this.$router.push('/word_1?title=贵州省建筑业协会单位会员入会申请表')
    },
    //提交审核
    async sumbit() {
      if (this.issumbit) {
        Apply({content:this.unitinfo})
          .then(res => {
            console.log(res);
            this.$message({
              message:res.msg?res.msg:'申请成功',
              type:'sucess'
            })
            this.dialogVisible = true;
            this.step_1 = 2;
          })
          .catch(err => {
            this.$message.error(err);
          });
      }else{
        this.$message.error('请填写完表单')
      }
    },
    handleremove(index) {
      this.$set(this.unitinfo,`Businesslicense${index}`,[])
    },
    //证件信息上传文件
    handlesuccess2(index, fileList) {
      this.$set(this.unitinfo,`Businesslicense${index}`,[{url:fileList.data.host+fileList.data.url,name:fileList.data.originalName}])
    },
    //左边导航列表点击
    scrollleft(name, id) {
      this.scrollnum('#'+id);
    },
    //锚点滚动
    scrollnum(id) {
      document
        .querySelector(id)
        .scrollIntoView({ behavior: "smooth", block: "start" });
      // document.querySelector(id).scrollIntoView(true)
      // document.documentElement.scrollTop = document.documentElement.scrollTop - 78
    },
  },
};
</script>

<style lang="less" scoped>
.wrap {
  width: 100%;
  background: #eff3f8;
  .newadd {
    width: 100px;
    height: 36px;
    border: 1px solid #194abe;
    border-radius: 3px;
    text-align: center;
    line-height: 36px;
    color: #194abe;
    margin: 0 0 20px 20px;
    box-sizing: border-box;
    cursor: pointer;
  }
  .flex {
    display: flex;
    align-items: center;
  }
  .my_form,
  .my_form2 {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    overflow: auto;
    align-items: stretch;
    .form_title {
      background: #eaf0f6;
      width: 129px;
      min-width: 129px;
      height: auto;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 14px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      line-height: 20px;
      padding: 0 6px;
      box-sizing: border-box;
      color: #0c0d0f;
    }
    .uploadinput {
      display: flex;
      flex-direction: column;
      justify-content: center;
      .uploadlist {
        display: flex;
        align-items: center;
      }
      input {
        width: 257px;
        height: 36px;
        background: #ffffff;
        border: 1px solid #bdc3cb;
        opacity: 1;
        border-radius: 4px;
        padding: 0 15px;
        box-sizing: border-box;
        &:focus {
          outline: none;
          border: 1px solid #194abe;
        }
      }
      .input {
        width: 257px;
        display: flex;
        position: relative;
        display: flex;
        align-items: center;
        margin-left: 20px;
        span {
          position: absolute;
          right: 10px;
          top: 50%;
          transform: translateY(-50%);
        }
      }
    }
    .form_content,
    .form_long,
    .form_choice {
      width: 300px;
      padding: 0px 6px;
      background: #f5f8fb;
      display: flex;
      align-items: center;
      justify-content: center;
      box-sizing: border-box;
      input {
        width: 257px;
        height: 36px;
        background: #ffffff;
        border: 1px solid #bdc3cb;
        opacity: 1;
        border-radius: 4px;
        padding: 0 15px;
        box-sizing: border-box;
        &:focus {
          outline: none;
          border: 1px solid #194abe;
        }
      }
      .input {
        width: 257px;
        display: flex;
        position: relative;
        span {
          position: absolute;
          right: 10px;
          top: 50%;
          transform: translateY(-50%);
        }
      }
    }
    .form_choice_long {
      display: flex;
      justify-content: start;
      align-items: center;
      width: 729px;
      padding-left: 20px;
      box-sizing: border-box;
      background: #f5f8fb;
    }
    .form_long {
      width: 729px;
      input {
        width: 688px;
      }
    }
    .form_textarea {
      width: 729px;
      height: 188px;
      display: flex;
      background: #f5f8fb;
      flex-direction: column;
      justify-content: space-evenly;
      padding-left: 20px;
      textarea {
        width: 688px;
        height: 127px;
        background: #ffffff;
        border: 1px solid #bdc3cb;
        opacity: 1;
        border-radius: 4px;
        padding: 9px 15px;
        box-sizing: border-box;
        color: #000;
        &:focus {
          outline: none;
          border: 1px solid #194abe;
        }
      }
    }
    .uploadimg {
      width: 729px;
      padding: 20px;
      background: #f5f8fb;
      box-sizing: border-box;
    }
    .Downinpustyle {
      display: flex;
      flex-wrap: wrap;
      align-items: center;
      background: #f5f8fb;
      .nejje {
        color: #194abe !important;
      }
    }
    .upload-demo {
      width: 729px;
      padding-left: 20px;
      background: #f5f8fb;
      display: flex;
      align-items: center;
      box-sizing: border-box;
      height: 100px;
      .el-upload__tip {
        margin-left: 10px;
      }
    }
  }
  .my_formmin,
  .my_form2min {
    width: 286px;
    .form_title {
      width: 86px;
      min-width: 86px;
      padding: 20px 5px;
    }
    .form_content {
      width: 200px;
      display: flex;
      flex-direction: column;
    }
    input,
    .input {
      width: 171px !important;
      margin: 5px 0;
    }
  }
  .my_form {
  }
  .my_form2 {
    .form_title {
      background: #f5f8fb;
    }
    .form_content,
    .form_long,
    .form_textarea,
    .form_choice,
    .form_choice_long,
    .upload-demo,
    .Downinpustyle {
      background: #fbfdff;
    }
  }

  //   顶部title样式
  .header_title {
    width: 100%;
    margin: 0 auto;
    height: 58px;
    background: #ffffff;
    box-shadow: 0px 6px 12px rgba(0, 17, 58, 0.06);
    position: fixed;
    top: 0;
    left: 0;
    z-index: 999999;
    .header_center {
      width: 1200px;
      margin: 0 auto;
      height: 58px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      .title {
        font-size: 20px;
        font-family: Source Han Sans CN;
        font-weight: bold;
        line-height: 29px;
        color: #0c0d0f;
        span {
          font-size: 22px;
          line-height: 32px;
          color: #194abe;
        }
      }
      .back_page {
        cursor: pointer;
        width: 124px;
        height: 36px;
        background: #ffffff;
        border: 1px solid #c8cdd5;
        opacity: 1;
        border-radius: 6px;
        line-height: 36px;
        color: #7c828a;
      }
    }
  }

  // form_box样式
  .form_box {
    max-width: 1200px;
    min-width: 1200px;
    margin: 0 auto;
    margin-top: 78px;
    display: flex;
    justify-content: space-between;
    .tips {
      width: 20px;
      height: 20px;
    }
    .nav_left,
    .form_right {
      border-radius: 6px;
    }
    .nav_left {
      position: fixed;
      width: 268px;
      .nav_title,
      .nav_list {
        background: #ffffff;
        width: 100%;
        text-align: start;
        padding: 0 16px;
        box-sizing: border-box;
      }
      .nav_title {
        height: 53.5px;
        font-size: 20px;
        font-family: Source Han Sans CN;
        font-weight: bold;
        line-height: 53.5px;
        color: #0c0d0f;
        border-radius: 6px 6px 0px 0px;
      }
      .nav_list {
        margin-top: 2px;
        height: 350px;
        overflow-y: scroll;
        overflow-x: hidden;
        border-radius: 0px 0px 6px 6px;
        &::-webkit-scrollbar {
          width: 6px;
          height: 1px;
        }
        &::-webkit-scrollbar-thumb {
          border-radius: 5px;
          background-color: #b7c8f1;
        }
        .list {
          width: 100%;
          height: 57px;
          border-bottom: 1px dashed #d4dbdd;
          display: flex;
          align-items: center;
          p {
            margin-left: 13px;
            font-size: 16px;
            font-family: Source Han Sans CN;
            font-weight: 400;
            line-height: 24px;
            overflow: hidden;
            word-break: break-all;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 2;
          }
        }
      }
      .preview {
        margin-top: 17px;
        width: 100%;
        height: 201px;
        padding: 16px;
        box-sizing: border-box;
        background: white;
        border-radius: 0px 0px 6px 6px;
        .preservation,
        .online,
        .sumbit {
          cursor: pointer;
          width: 236px;
          height: 50px;
          background: #ffffff;
          opacity: 1;
          border-radius: 4px;
          box-sizing: border-box;
          display: flex;
          align-items: center;
          justify-content: center;
          img {
            width: 15px;
            height: 15px;
            margin-right: 4px;
          }
        }
        .blue {
          background: #194abe !important;
        }
        .preservation {
          border: 1px solid #194abe;
          color: #194abe;
        }
        .online {
          margin: 10px 0;
          border: 1px solid #1abf98;
          color: #1abf98;
        }
        .sumbit {
          background: #d4dbdd;
          border-radius: 4px;
          font-size: 18px;
          font-family: Microsoft YaHei;
          font-weight: bold;
          line-height: 27px;
          color: #ffffff;
          img {
            width: 18px;
            height: 14px;
          }
        }
      }
    }
    .form_right {
      margin-left: 300px;
      width: 918px;
      .flex {
        display: flex;
      }
      .flex-direction {
        flex-direction: column;
      }
      .form_1 {
        width: 100%;
        background: #ffffff;
        padding: 35px 30px;
        box-sizing: border-box;
        margin-bottom: 30px;
        border-radius: 6px;
        .border {
          border-top: 1px dashed #9fa5ae;
          margin: 20px 0;
        }
        .bord {
          margin-top: 11px;
          width: 858px;
          height: 0px;
          border: 1px solid #194abe;
          position: relative;
          img {
            width: 11px;
            height: 6px;
            position: absolute;
            top: -6px;
            left: 37px;
          }
        }
        .newlybuild {
          margin: 0 auto;
          cursor: pointer;
          width: 221px;
          height: 36px;
          border: 2px solid #194abe;
          border-radius: 4px;
          display: flex;
          justify-content: center;
          align-items: center;
          img {
            width: 16px;
            height: 16px;
            margin-right: 7px;
          }
          p {
            font-size: 14px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            line-height: 14px;
            color: #194abe;
          }
        }
        .form_box_content {
          width: 100%;
          margin-top: 20px;
          .form_title {
            box-sizing: border-box;
            text-align: start;
            display: flex;
            align-items: center;
            p {
              font-size: 16px;
              font-family: Microsoft YaHei;
              font-weight: bold;
              line-height: 20px;
              color: #0c0d0f;
            }
            .delete_icon {
              cursor: pointer;
              margin-left: 10px;
              width: 61px;
              height: 25px;
              background: #ffffff;
              border: 1px solid #f9656f;
              opacity: 1;
              border-radius: 6px;
              display: flex;
              align-items: center;
              justify-content: space-evenly;
              img {
                width: 13px;
                height: 14px;
              }
              p {
                font-size: 14px;
                font-family: Source Han Sans CN;
                font-weight: 400;
                line-height: 20px;
                color: #f9656f;
              }
            }
          }
        }
      }
    }
  }
}
</style>
<style>
.el-upload-list {
  height: 50px;
  display: flex;
  align-items: center;
}
.el-upload-list__item {
  transition: none !important;
}
</style>